import Vue from 'vue'

Vue.filter('currency', function (value) {
  if (value) {
    return parseFloat(value).toFixed(2)
  }
  return value
})

Vue.filter('percent', function (value) {
  if (value) {
    return parseFloat(value).toFixed(2) + '%'
  }
  return value
})

Vue.filter('number', function (x) {
  if (x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  return x
})
